import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

import { BLACK, PRIMARY_PURPLE } from '../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../theme/fontConstants';
import { epochToDateInReadableFormat } from '../../../utils';
import { WEEKLY_DAILY_OPTIONS } from '../timekeepingConstants';
import {
  getEndOfDayInEpoch,
  getEndOfWeekInEpoch,
  getShiftedRangeInEpoch,
  getStartOfDayInEpoch,
  getStartOfWeekInEpoch,
} from '../timekeepingHelpers';

import DailyWeeklyDateSelector from './DailyWeeklyDateSelector';

const TimekeepingDayWeekFilter = ({
  startEpoch,
  endEpoch,
  isDaily,
  handleOnWeeklyDailyFilterChange,
}) => {
  const isForwardDisabled = endEpoch > Date.now();

  const handleBackButtonClick = useCallback(() => {
    handleOnWeeklyDailyFilterChange(getShiftedRangeInEpoch({ startEpoch, isDaily, shift: -1 }));
  }, [handleOnWeeklyDailyFilterChange, startEpoch, isDaily]);

  const handleForwardButtonClick = useCallback(() => {
    handleOnWeeklyDailyFilterChange(getShiftedRangeInEpoch({ startEpoch, isDaily, shift: 1 }));
  }, [handleOnWeeklyDailyFilterChange, startEpoch, isDaily]);

  const onSelectedValueChange = useCallback(
    (data) => {
      if (data?.type === WEEKLY_DAILY_OPTIONS.daily.value) {
        handleOnWeeklyDailyFilterChange({
          startDate: getStartOfDayInEpoch(data?.date),
          endDate: getEndOfDayInEpoch(data?.date),
        });
      }
      if (data?.type === WEEKLY_DAILY_OPTIONS.weekly.value) {
        handleOnWeeklyDailyFilterChange({
          startDate: getStartOfWeekInEpoch(data?.date),
          endDate: getEndOfWeekInEpoch(data?.date),
        });
      }
    },
    [handleOnWeeklyDailyFilterChange]
  );

  return (
    <Grid container item justifyContent="space-between" direction="row">
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Box sx={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
          <DailyWeeklyDateSelector onChange={onSelectedValueChange} />
          <Typography
            sx={{
              color: `${BLACK[70]}`,
              fontFamily: 'Barlow-700',
              fontSize: '18px',
              width: '120px',
              padding: 1,
            }}
          >
            {isDaily
              ? LanguageConverterV2(WEEKLY_DAILY_OPTIONS.daily.label)
              : LanguageConverterV2(WEEKLY_DAILY_OPTIONS.weekly.label)}
          </Typography>

          <IconButton size="small" onClick={handleBackButtonClick}>
            <KeyboardArrowLeft sx={{ color: PRIMARY_PURPLE[70] }} />
          </IconButton>

          <Typography
            sx={{
              color: `${BLACK[70]}`,
              fontFamily: PRIMARY_FONT[400],
              fontSize: '20px',
              marginLeft: '8px',
              marginRight: '8px',
            }}
          >
            {isDaily
              ? epochToDateInReadableFormat(startEpoch)
              : `${epochToDateInReadableFormat(startEpoch)} - ${epochToDateInReadableFormat(
                  endEpoch
                )}`}
          </Typography>
          <IconButton disabled={isForwardDisabled} size="small" onClick={handleForwardButtonClick}>
            <KeyboardArrowRight sx={{ color: PRIMARY_PURPLE[70] }} />
          </IconButton>
        </Box>
      </Box>
    </Grid>
  );
};
export default TimekeepingDayWeekFilter;

TimekeepingDayWeekFilter.propTypes = {
  startEpoch: PropTypes.number.isRequired,
  endEpoch: PropTypes.number.isRequired,
  isDaily: PropTypes.bool,
  handleOnWeeklyDailyFilterChange: PropTypes.func,
};
